import React from 'react'

function ErrorPageComp() {
    return (
        
        <div className="error_container">
            <img src="assets/images/internal_error.png" alt="" />
            <div className="error_detail">
                <h1>403  <span>Forbidden</span></h1>
                <p>Sorry, you're allowed in here.</p>
                <p>Please contact IT.</p>
            </div>
        </div>
    )
}

export default ErrorPageComp
